import React, { useEffect, useState } from 'react'
import { Route, Redirect, useHistory } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import ClientLayout from 'layouts/Client'
import {
    fetchRequestTutorHistory,
} from "redux/ScheduleTutor/ScheduleTutorActions";
import Swal from 'sweetalert2'
import { updateUserIntroductoryCall } from 'redux/Users/UsersActions';
import { fetchSettings } from 'redux/Settings/SettingsAction'

const ClientRoute = ({ component: Component, authenticated, admin, authChecked, loading, userDetails, updateUserProfile, fetchRequestTutorHistoryState, ...rest }) => {

    const dispatch = useDispatch()
    const history = useHistory();

    useEffect(() => {
        dispatch(fetchSettings())
    }, [])


    // useEffect(() => {

    //     if(authenticated){

    //         if(typeof userDetails.applicationCycle != "undefined"){
    //             if(["true", true].includes(userDetails.ultimateAdvisingStudent)){
    //                 dispatch(fetchRequestTutorHistory({ studentHandle: userDetails.handle }))
    //             }
    //         }
    //         else{

    //             if (!["true", true].includes(userDetails?.coach) && !["true", true].includes(userDetails?.admin)) {
    //                 setTimeout(() => {
    //                     Swal.fire({
    //                         title: 'Application Cycle',
    //                         text: "You must select an application cycle.",
    //                         icon: 'info',
    //                         showCancelButton: false,
    //                         confirmButtonColor: '#5e72e4',
    //                         confirmButtonText: 'Go to My Profile',
    //                         cancelButtonText: 'Completed',
    //                         allowOutsideClick: false

    //                     }).then((result) => {
    //                         history.push("/client/my-profile")
    //                     })
    //                 }, 5000); 
    //             }
    //         }
    //     }




    // }, [authenticated])

    const isValidUSE164 = (s) => /^\+1[2-9]\d{2}[2-9]\d{6}$/.test(s);

    const isValidUSNumber = (input) => {
        const d = (input || "").replace(/\D/g, "");

        const e164 =
            d.length === 10 ? `+1${d}` :
                (d.length === 11 && d.startsWith("1") ? `+${d}` : null);
        return e164 ? isValidUSE164(e164) : false;
    };

    useEffect(() => {
        
        if (typeof userDetails.handle != "undefined" && !updateUserProfile.loading) {

            

            const applicationCycle = (typeof updateUserProfile.userprofile?.[0]?.selectedApplicationCycle != "undefined" && updateUserProfile.userprofile?.[0]?.selectedApplicationCycle != "")
                || (typeof userDetails.applicationCycle != "undefined" && userDetails?.applicationCycle != "");

            if (applicationCycle) {
                if (["true", true].includes(userDetails.ultimateAdvisingStudent)) {
                    dispatch(fetchRequestTutorHistory({ studentHandle: userDetails.handle }))
                }
            }
            else {

                if (!["true", true].includes(userDetails?.coach) && !["true", true].includes(userDetails?.admin)) {
                    setTimeout(() => {
                        Swal.fire({
                            title: 'Application Cycle',
                            text: "You must select an application cycle.",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#5e72e4',
                            confirmButtonText: 'Go to My Profile',
                            cancelButtonText: 'Close',
                            allowOutsideClick: true

                        }).then((result) => {
                            if(result.isConfirmed){
                                if (history.location.pathname != "/client/my-profile") {
                                    history.push("/client/my-profile")
                                }
                            }
                            

                        })
                    }, 5000);
                }


            }



            const phoneNumber = updateUserProfile.userprofile?.[0]?.phoneNumber ? updateUserProfile.userprofile?.[0]?.phoneNumber : userDetails.phoneNumber;
            
            if (!isValidUSNumber(phoneNumber)) {
               
                setTimeout(() => {
                    Swal.fire({
                        title: 'Phone Number',
                        text: userDetails.phoneNumber ? "Not valid. Please re-enter your phone number." : "Enter a valid 10-digit U.S. phone number.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#5e72e4',
                        confirmButtonText: 'Go to My Profile',
                        cancelButtonText: 'Close',
                        allowOutsideClick: true
                    }).then((result) => {
                        if(result.isConfirmed){
                            if (history.location.pathname != "/client/my-profile") {
                                history.push("/client/my-profile")
                            }
                        }
                    });
                }, 5000);

            }
            

        }

    }, [updateUserProfile])
    
    const [introductoryCallPopup, setIntroductoryCallPopup] = useState(false)
    useEffect(() => {
        if (history.location.pathname != "/client/schedule-tutor" && !introductoryCallPopup) {
            if (fetchRequestTutorHistoryState.fetchrequesttutorhistory.length) {

                if (fetchRequestTutorHistoryState.fetchrequesttutorhistory[0].length == 0 && (userDetails.introductoryCall == false || typeof userDetails.introductoryCall == "undefined") && (userDetails.ultimateAdvisingStudent === true || userDetails.ultimateAdvisingStudent === "true") == true) {

                    // if(userDetails.ultimateAdvisingStudent === true || userDetails.ultimateAdvisingStudent === "true" ){

                    Swal.fire({

                        title: 'Introductory Call',

                        html: "<p style='font-weight: bold;'>Schedule a 1:1 session with any of the following coaches:</p><li><strong>Hannah Hamwi</strong></li><li><strong>Raj Patel</strong></li><li><strong>Sebastian Sass</strong></li><li><strong>Josiah Crombie</strong></li>",
                        icon: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Schedule',
                        cancelButtonText: 'Completed'

                    }).then((result) => {
                        
                        setIntroductoryCallPopup(true)
                        if (result.isConfirmed) {



                            history.push("/client/schedule-tutor")
                        }
                        else {
                            if (result.dismiss == "cancel") {

                                dispatch(updateUserIntroductoryCall({ handle: userDetails.handle, introductoryCall: true }))
                            }
                        }

                    })
                    // }
                }

            }
        }

    }, [fetchRequestTutorHistoryState])

    return (
        <Route {...rest}
            render={(props) => {
                // Show loading while checking authentication
                if (!authChecked || loading) {
                    Swal.fire({
                        title: 'Loading...',
                        text: 'Please wait while loading',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    return null;
                } else {
                    // Always close any existing Swal when auth check is complete
                    if (Swal.isVisible()) {
                        Swal.close();
                    }
                }

                if (authenticated === true) {
                    if (admin === true) {

                        return <Redirect to="/admin/dashboard" />
                    } else {

                        return <ClientLayout><Component {...props} /></ClientLayout>
                    }
                } else {
                    return <Redirect to="/auth/login" />
                }
            }
            }
        />
    )
}
const mapStateToProps = (state) => ({
    authenticated: state.loginAuth.authenticated,
    admin: state.loginAuth.admin,
    authChecked: state.loginAuth.authChecked,
    loading: state.loginAuth.loading,
    userDetails: state.loginAuth.userDetails,
    updateUserProfile: state.updateUserProfile,
    fetchRequestTutorHistoryState: state.fetchRequestTutorHistory,

})


export default connect(mapStateToProps)(ClientRoute)
